import { WidgetConfig } from './types';
import { getCSSStyles } from './helpers';

export class TraderverseTestFile {
  private container: HTMLElement;
  private shadowRoot: ShadowRoot;
  constructor(config: WidgetConfig) {
    this.container = this.resolveContainer(config.container);

    if ((this.container as any).shadowRoot) {
      this.shadowRoot = (this.container as any).shadowRoot;
    } else {
      this.shadowRoot = this.container.attachShadow({ mode: 'closed' });
    }

    this.attachStyles();
    this.renderHelloWorld();
  }
  

  private async attachStyles(): Promise<void> {
    try {
      const styleEl = await getCSSStyles();
      this.shadowRoot.appendChild(styleEl);
    } catch (err) {
      console.error('Failed to load CSS file:', err);
    }
  }

  private resolveContainer(container: string | HTMLElement): HTMLElement {
    if (typeof container === 'string') {
      const el = document.getElementById(container) || document.querySelector(container);
      if (!el) throw new Error(`Container not found: ${container}`);
      return el as HTMLElement;
    }
    return container;
  }

  private renderHelloWorld(): void {
    this.shadowRoot.innerHTML = `
      <div style="display:flex; align-items:center; justify-content:center; height:100%; font-size:24px; font-weight:bold;">
        Hello World!
      </div>
    `;
  }
}

declare global {
  interface Window { TraderverseTestFile?: typeof TraderverseTestFile; }
}

if (typeof window !== 'undefined') {
  window.TraderverseTestFile = TraderverseTestFile;
}
